import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class RecoveryResourcesCrudIntegration {
    constructor(service) {
        this.service = service;
    }

    async fetchAll(params = {}) {
        try {
            const response = await this.service.getAll(params);
            return { success: true, data: response.data || [], pagination: response.pagination || {} };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, data: [] };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:recoveryResourceCreatedSuccessfully', { defaultValue: 'Recovery resource created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:recoveryResourceUpdatedSuccessfully', { defaultValue: 'Recovery resource updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async delete(id) {
        try {
            const response = await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:recoveryResourceDeletedSuccessfully', { defaultValue: 'Recovery resource deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.service.batchDelete(ids);
            toast.success(i18next.t('integrationToasts:recoveryResourcesDeletedSuccessfully', { defaultValue: 'Recovery resources deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }
}
